import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/sagas/funnelChart/funnelChart";
import DatePicker from "./smartComponents/datePicker";
import CustomDateRange from "./smartComponents/customDateRange";
import FunnelGraph from "./smartComponents/funnelGraph";
import IntroOfferFunnelGraph from "./smartComponents/introOfferFunnelGraph";
import LearnMore from "../../../../components/learnMore/learnMore";
import ReferralBreakdownTable from "./smartComponents/referralBreakdownTable";
import StartFromFilter from "./smartComponents/startFrom";
import styles from "./funnelChart.module.css";
import { BOOKING_COUNTING_STATUSES } from "./constants";
import { addSticky } from "../../../../utils/addSticky";
import { Averages } from "./smartComponents/averages";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { SubAverageFilter } from "./smartComponents/subAverageFilter";

export class FunnelGraphModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersDirty: false,
      checkedFutureAppointment: false,
      checkedLoose: false
    };
  }

  componentDidMount() {
    this.props.fetchTableData(this.props.userParams);
    if (this.props.userParams.params.showFutureAppointmentByDefault) {
      this.setState({
        checkedFutureAppointment: true
      });
    }
  }
  componentDidUpdate() {
    if (!this.props.isLoading) {
      addSticky();
    }
  }

  handleResetData = () => {
    this.props.resetData(this.props.userParams);

    this.setState({
      filtersDirty: false
    });
  };

  handleChangeLoose = (event) => {
    let active = event.target.checked;

    this.props.toggleLoose(active);
    this.setState({
      checkedLoose: active
    });
  };

  handleChangeFutureAppointment = (event) => {
    let active = event.target.checked;

    this.props.toggleFutureAppointment(active);
    this.setState({
      checkedFutureAppointment: active
    });
  };

  shouldShowResetButton = () => {
    return this.props.filtersDirty && !this.props.isLoading;
  };

  shouldShowUpdateButton = () => {
    const { selectedRequestDates } = this.props;

    return (
      this.shouldShowResetButton() &&
      selectedRequestDates.startDate !== "Invalid date" &&
      selectedRequestDates.endDate !== "Invalid date"
    );
  };

  renderChartFilters = () => {
    const showAppointmentsToggle =
      this.props.userParams.params.showFutureAppointment && this.props.isLeadSelected;
    return (
      <div className={this.props.showLaserNetworkAverages ? "with-average" : ""}>
        {/** Select Filters */}
        <div data-testid="filters" className="filters">
          <div className="top-filters">
            <div>
              <div className="select-box">
                <p className="offers-title">Date Range</p>
                {!this.state.filtersDirty && <CustomDateRange />}
              </div>

              <div className="date-select-box select-box multi" style={{ width: "286px" }}>
                <p className="offers-title">Date</p>
                {!this.state.filtersDirty && <DatePicker />}
              </div>
            </div>
            <div className="start-from-wrapper">
              <div className="select-box">
                <p className="offers-title">Start From</p>
                <StartFromFilter />
              </div>
              {this.props.showLaserNetworkAverages ? (
                <div className="select-box" style={{ width: "150px" }}>
                  <p className="offers-title">Averages</p>
                  <Averages />
                </div>
              ) : null}
              {this.props.subAverageFilterOptions[this.props.average]?.length ? (
                <div className="select-box" style={{ width: "150px" }}>
                  <p className="offers-title">{this.props.average}</p>
                  <SubAverageFilter />
                </div>
              ) : null}
            </div>
          </div>
          <div
            className={this.props.selectedShow && !showAppointmentsToggle ? "selected-show" : ""}
          >
            {this.shouldShowUpdateButton() && (
              <button className="submit" onClick={this.props.updateChart}>
                Update
              </button>
            )}
            {this.shouldShowResetButton() && (
              <button className="submit reset" onClick={this.handleResetData}>
                Reset
              </button>
            )}
          </div>
        </div>

        {/** Switch Filters */}
        {/* TODO: remove 2 from input after deleting old chart*/}
        <div className="filters">
          <div>
            {showAppointmentsToggle ? (
              <div className="select-box toggle" style={{ width: 203 }}>
                <p className="offers-title">Future Appointment</p>
                <input
                  type="checkbox"
                  className="ios8-switch"
                  id="future-toggle2"
                  checked={this.state.checkedFutureAppointment}
                  onChange={this.handleChangeFutureAppointment}
                />
                <label htmlFor="future-toggle2" />
              </div>
            ) : null}

            {!this.props.selectedShow ? (
              <div className="select-box toggle" style={{ width: 203 }}>
                <p className="offers-title">Include Loose Conversions</p>
                <input
                  type="checkbox"
                  className="ios8-switch"
                  id="loose-toggle2"
                  checked={this.state.checkedLoose}
                  onChange={this.handleChangeLoose}
                />
                <label htmlFor="loose-toggle2" />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  renderChartDataSummary = () => {
    const {
      total,
      startFromAppointment,
      averageNumberOfDaysToAppointment,
      averageNumberOfDaysToConversion,
      sourceType,
      disableAnimation,
      averageTooltip: toolTip
    } = this.props;

    const sectionStyle = { style: { paddingRight: "100px" } };

    return (
      <div data-testid="laser-data-summary" className="section-group flex">
        {total && (
          <DataDisplay
            label={total.label}
            value={total.value}
            url={total.url}
            sectionProps={{ style: { paddingRight: "200px" } }}
            averageProps={{ average: total.average, toolTip }}
            disableAnimation={disableAnimation}
          />
        )}

        {!startFromAppointment && averageNumberOfDaysToAppointment && sourceType === "clubready" ? (
          <DataDisplay
            label={averageNumberOfDaysToAppointment.label}
            value={averageNumberOfDaysToAppointment.value}
            sectionProps={sectionStyle}
            averageProps={{
              average: averageNumberOfDaysToAppointment.average,
              toolTip
            }}
            disableAnimation={disableAnimation}
          />
        ) : (
          ""
        )}

        {averageNumberOfDaysToConversion === undefined || averageNumberOfDaysToConversion.hide ? (
          ""
        ) : (
          <DataDisplay
            label={averageNumberOfDaysToConversion.label}
            value={averageNumberOfDaysToConversion.value}
            sectionProps={sectionStyle}
            averageProps={{
              average: averageNumberOfDaysToConversion.average,
              toolTip
            }}
            disableAnimation={disableAnimation}
          />
        )}
      </div>
    );
  };

  renderIntroOfferChartDataSummary = () => {
    const { combinedStats } = this.props.funnelIntroOffers;
    const averageTooltip = this.props.averageTooltip;

    if (!combinedStats.length) return null;

    return (
      <React.Fragment>
        <div className="section-group flex">
          {combinedStats.map((combinedStat, index) => (
            <div className={styles.statsItemContainer} key={`combinedStat-${index}`}>
              {combinedStat.map((singleStat, singleStatIndex) =>
                !singleStat ? (
                  <div key={`singleStat-${singleStatIndex}`} />
                ) : (
                  <DataDisplay
                    key={singleStat.label}
                    label={singleStat.label}
                    value={singleStat.value}
                    url={singleStat.url}
                    averageProps={{ average: singleStat.average, toolTip: averageTooltip }}
                    sectionProps={{
                      style: { paddingRight: "100px" },
                      rootClassName: styles.statsItem
                    }}
                    disableAnimation={this.props.disableAnimation}
                  />
                )
              )}
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div data-testid="funnel-chart-module" className="funnel-chart-module">
        <SectionToggle
          hideToggle
          autoHeight
          title={this.props.userParams.params.moduleName}
          customClass="laser withSticky"
          isLoading={this.props.isLoading}
          learnMore={<LearnMore {...learnMoreProps(this.props)} />}
          content={
            <div className="flex flex-col">
              {/* Filters */}
              <div id="sticky-select-bar" className="edit-selections-bar">
                {this.renderChartFilters()}
              </div>
              {this.props.tablesLoading ? (
                <LoadingAnimation />
              ) : (
                <div className="flex flex-col" style={{ paddingTop: "50px" }}>
                  {/* Number summaries */}

                  {this.props.isIntroOfferSelected
                    ? this.renderIntroOfferChartDataSummary()
                    : this.renderChartDataSummary()}

                  {/* Graph section */}
                  <div style={{ paddingTop: 25, float: "left" }}>
                    <SectionContainer title={this.props.title} style={{ padding: "0 100px 0 0" }}>
                      {this.props.isIntroOfferSelected ? (
                        <IntroOfferFunnelGraph />
                      ) : (
                        <FunnelGraph />
                      )}
                    </SectionContainer>
                  </div>

                  {/* Table section */}
                  <div className="section-group flex" style={{ paddingTop: 50 }}>
                    <SectionContainer title="" rootClassName="referral-breakdown-container">
                      {this.props.referralTableData.length > 0 ? (
                        <ReferralBreakdownTable
                          table={this.props.referralTable}
                          sourceType={this.props.sourceType}
                          isRowHouse={this.props.orgName === "Row House"}
                        />
                      ) : (
                        ""
                      )}
                    </SectionContainer>
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

const learnMoreProps = (props) => {
  return {
    learnMoreId: "funnel_laser_learn_more",
    title: props.userParams.params.moduleName,
    content:
      "mindbody" === props.sourceType ? (
        <>
          <h3>Start From Drop Down: </h3>
          <p>Choose which to start the funnel at - the lead, the appointment or the intro sale.</p>
          <p>
            <h3>
              When started from the <b>Lead</b>
            </h3>
            <b>Lead</b> will count any new profile based on the date of creation.
            <br />
            <b>Appointment</b> counts how many of those leads have scheduled their first booking.
            <br />
            <b>Show</b> counts the number of those leads that scheduled their first booking, who
            completed a visit.
            <br />
            <b>Enrollment</b> counts how many of the leads that book and showed for their first
            class or appointment that make a qualifying purchase.
            <br />
          </p>
          <br />
          <p>
            <h3>
              When started from the <b>Appointment</b>
            </h3>
            <b>Appointment</b> counts how many first bookings regardless of when the profile was
            created.
            <br />
            <b>Show</b> counts the number of first bookings that completed their first visit.
            <br />
            <b>Enrollment</b> counts how many of the clients with first bookings and a completed
            class or appointment that make a qualifying purchase.
            <br />
          </p>
          <br />
          <p>
            <h3>
              When started from the <b>Intro Offer</b>
            </h3>
            <b>Intro Offer</b> will count the number of purchases of a pricing option/package that
            is tagged as an Introductory Offer.
            <br />
            <b>First Visit</b> will count the number of those intro offers that completed their
            first visits.
            <br />
            <b>Converted</b> will counts how many of the clients that purchased an Intro Offer,
            completed a first visit then purchased a qualifying pricing option/package.
            <br />
          </p>
          <br />
          <p>
            <h3>Enrollment/Converted:</h3>
            Hovering over the enrollment/converted part of the funnel will display clickable options
            that break down enrollment purchases by Membership, Intro Offers, and Other Packages. If
            a client purchases multiple items, then the order of priority is membership, intro
            offers, then other packages.
          </p>
          <br />
          {props.userParams.params.showFutureAppointment ? (
            <>
              <br />
              <h3>Future Appointment Toggle</h3>
              <p>
                When toggled on [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>
                ], the laser chart will look for future appointments for the leads shown in the
                chart. For example, the calendar end date is set from January 1st to January 31st
                and today is January 31st. When toggled on, it will find appointments set in
                February, in the future. If the leads have appointments booked in the future this
                will affect metrics as an increase to Lead to Appointment Percentage, a decrease to
                Appointment to Show Percentage and an increase to the Appointment total metric.
              </p>
            </>
          ) : (
            ""
          )}
          <h3>Include Loose Conversions Toggle</h3>
          <p>
            Off [<span style={{ fontWeight: "bold" }}>white</span>] - A client will not be counted
            as enrolled/converted if they do not have an appointment and show when the funnel is
            started from the lead. Nor will the client be counted as converted if they do not have a
            first visit when the funnel is starting from the Intro Offer.
            <br />
            On [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>] - A client can
            be counted as enrolled/converted even if they have not completed the other steps in the
            funnel; Appointment, Show or First Visit.
          </p>
        </>
      ) : (
        <>
          <p>
            The iKizmet LASER module was created to see where your leads are currently in your sales
            funnel. This report will NOT match what you will see in the referrals report in
            ClubReady. The date selector will only capture the “Start From” data. All the other data
            is not confined to the date selector. The funnel will start from a particular set of
            data and all additional steps of the funnel will
          </p>
          <h3>Start From </h3>
          <p>This filter will set the data the funnel will start from.</p>
          <p>
            The default “Start From” is the Lead (Profile Creation). When this is your start, the
            date selector will only gather leads (based on the profile creation date) that fall
            under that date range. In this scenario, the Appointments, Show and Enrollment data will
            be limited to those that are in the Lead data.
          </p>
          <p>
            You can also have the funnel start from the Appointment stage. The chart will skip the
            lead portion of the funnel to start the funnel from when a client makes their first
            appointment. This feature is here because often times leads will be entered long ago and
            finally make their first appointment months later. In this scenario, the lead will have
            recently converted but if the funnel calendar is set to a recent time period, they will
            be excluded as a conversion because the default load is by lead entered date.
          </p>
          <p>
            The last start of the funnel is the purchase of an Intro Offer. This will ignore both
            lead and/or appointment and only start the funnel when a client purchases a qualifying
            introductory offer. This will be based on sale date of the offer. Please note, only
            packages that are tagged in iKizmet as Intro Offer will be tracked.
          </p>
          <h3>Network Averages</h3>
          <p>
            If your brand/organization has this feature turned on, you will be able to compare your
            stats to other store in your organization. The smaller number in the rounded square is
            average depending on the filter you selected.
          </p>
          <p>
            The filters can have available are the ‘network’, all the stores that are loaded in
            iKizmet for your brand. Or you can choose to select your division’, or ‘district’ that
            your store is connected to in ClubReady. You can also select your iKizmet Region.
          </p>
          {props.userParams.params.showFutureAppointment ? (
            <>
              <br />
              <br />
              <h3>Future Appointment Toggle</h3>
              <p>
                When toggled on [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>
                ], the LASER chart will look for future appointments for the leads shown in the
                chart. For example, the calendar date is set from January 1st to January 31st, and
                today is January 31st. When toggled on, it will find appointments set in February,
                in the future. If the leads have appointments booked in the future this will affect
                metrics as an increase to Lead to Appointment Percentage, a decrease to Appointment
                to Show Percentage and an increase to the Appointment total metric.
              </p>
            </>
          ) : (
            ""
          )}
          <br />
          <br />
          <h3>Include Loose Conversions Toggle</h3>
          <p>
            Off [<span style={{ fontWeight: "bold" }}>white</span>] - A client will not be counted
            as enrolled/converted if they do not have an appointment and show when the funnel is
            started from the lead. Nor will the client be counted as converted if they do not have a
            first visit when the funnel is starting from the Intro Offer.
            <br />
            On [<span style={{ color: "#8fc447", fontWeight: "bold" }}>green</span>] - A client can
            be counted as enrolled/converted even if they have not completed the other steps in the
            funnel; Appointment, Show or First Visit.
          </p>
          <p>
            The <b>Lead</b> metric counts any new person added to a location on the day they are
            added. Leads are usually added the same day as their first visit but can also be added
            beforehand from a marketing effort, referral, website, or other online lead capture.
          </p>
          <p>
            The <b>Appointment</b> metric counts how many leads have scheduled an appointment or
            class visit. The difference between the appointments and leads totals is when a lead
            fails to schedule their first visit.
          </p>
          {"clubready" === props.sourceType ? (
            <table className={styles.tableLearn}>
              <thead>
                <tr>
                  <th />
                  <th>Appointment Status</th>
                  <th>Appointment</th>
                  <th>Show</th>
                </tr>
              </thead>
              <tbody>
                {BOOKING_COUNTING_STATUSES.map((value, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={styles.tableLearnRows}>
                      <b>{value.status}</b>
                      {value.description}
                    </td>
                    <td className={styles.tableLearnRows}>{value.appointment}</td>
                    <td className={styles.tableLearnRows}>{value.show}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            ""
          )}
          <p>
            The <b>Show</b> metric counts how many actually attend out of the leads that schedule an
            appointment or class. The difference between the appointment and show metrics are leads
            that “no show” their appointment and never have their first visit.
          </p>
          <p>
            The <b>Enrollment</b> metric counts how many of the clients that show for their first
            visit have a qualifying purchase. If desired, some purchases like free visits can be
            excluded as a qualifying purchase from the pricing option mapping page by clicking the
            “using for retention” button.
            <br />
            <br />
            <b>**Note:</b> <i>The client must show to be counted as enrolled.</i> <br />
          </p>
          <p>
            Hovering over the enrollment part of the funnel will display clickable options that
            break down enrollment purchases by Membership, Intro Offers, and Other Packages. If a
            client purchases multiple items then the order of priority is membership, intro offers,
            then other packages.
          </p>
        </>
      )
  };
};

export default connect(
  (state) => {
    let {
      isLoading,
      tablesLoading,
      selectedRequestDates,
      filtersDirty,
      funnelChartData: { funnel_laser },
      referralTable,
      currentUser: { organization_name, sourceType, showLaserNetworkAverages, current_object_id },
      isIntroOfferSelected,
      funnelIntroOffers,
      startFromAppointment,
      isLeadSelected,
      averageTooltip,
      selectedShow,
      average,
      subAverageFilterOptions
    } = state.funnelChart;

    return {
      isLoading,
      tablesLoading,
      selectedRequestDates,
      filtersDirty,
      total: funnel_laser.total,
      chart: funnel_laser.chart,
      referralTable: referralTable.referrals_table.tableInfo,
      referralTableData: referralTable.referrals_table.tableInfo.data,
      orgName: organization_name,
      averageNumberOfDaysToConversion: funnel_laser.averageNumberOfDaysToConversion,
      averageNumberOfDaysToAppointment: funnel_laser.averageNumberOfDaysToAppointment,
      hideAverageDaysToConversion: funnel_laser.hideAverageDaysToConversion,
      title: isIntroOfferSelected ? funnelIntroOffers.chart.label : funnel_laser.chart.title,
      sourceType,
      funnelIntroOffers: funnelIntroOffers,
      disableAnimation: true,
      startFromAppointment,
      isLeadSelected,
      isIntroOfferSelected: isIntroOfferSelected,
      showLaserNetworkAverages: showLaserNetworkAverages && current_object_id !== -1,
      averageTooltip,
      average,
      subAverageFilterOptions,
      selectedShow
    };
  },
  {
    fetchTableData: actionCreators.fetchTableData,
    updateChart: actionCreators.updateChart,
    toggleFutureAppointment: actionCreators.toggleFutureAppointment,
    toggleLoose: actionCreators.toggleLoose,
    resetData: actionCreators.resetData
  }
)(FunnelGraphModule);

FunnelGraphModule.propTypes = {
  userParams: PropTypes.object,
  fetchTableData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  selectedRequestDates: PropTypes.object,
  filtersDirty: PropTypes.bool,
  tablesLoading: PropTypes.bool,
  totalLabel: PropTypes.string,
  total: PropTypes.object,
  chart: PropTypes.object,
  averageNumberOfDaysToConversion: PropTypes.object,
  averageNumberOfDaysToAppointment: PropTypes.object,
  toggleFutureAppointment: PropTypes.func,
  toggleLoose: PropTypes.func,
  updateChart: PropTypes.func,
  orgName: PropTypes.string,
  title: PropTypes.string,
  sourceType: PropTypes.string,
  referralTable: PropTypes.object,
  referralTableData: PropTypes.array,
  funnelIntroOffers: PropTypes.object,
  disableAnimation: PropTypes.bool,
  isIntroOfferSelected: PropTypes.bool,
  startFromAppointment: PropTypes.bool.isRequired,
  isLeadSelected: PropTypes.bool.isRequired,
  showLaserNetworkAverages: PropTypes.bool,
  averageTooltip: PropTypes.string,
  average: PropTypes.string,
  subAverageFilterOptions: PropTypes.object,
  resetData: PropTypes.func,
  setSubAverageSelectedOptions: PropTypes.func,
  selectedShow: PropTypes.bool
};
